import { defineNuxtRouteMiddleware } from '#imports'

import { useUserStore } from '@backmarket/nuxt-layer-oauth/useUserStore'

import { useSellerInfoStore } from '~/scopes/auth/stores/sellerInfoStore'

export default defineNuxtRouteMiddleware(async () => {
  const userStore = useUserStore()
  const sellerInfoStore = useSellerInfoStore()

  if (
    userStore.isUserAuthenticatedSeller &&
    !sellerInfoStore.hasFetchSellerInfo
  ) {
    await sellerInfoStore.fetchSellerInfo()
  }
})
